import React from "react";
import mnnit_1 from "../assets/mnnit_1.jpg";
import mnnit_2 from "../assets/mnnit_2.jpg";
import mnnit_image from "../assets/mnnit_image.jpeg"; // Replace with the actual image path

const AboutInstitute = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
        {/* Left Content */}
        <div>
          <h2 className="text-2xl md:text-3xl mb-4">
            Host Institute: Motilal Nehru National Institute of Technology (MNNIT) Allahabad
          </h2>

          <p className="text-md md:text-lg text-gray-600 mb-4">
            MNNIT-Allahabad, established in 1961-62 and recently celebrated its Diamond Jubilee,
            is one of the National Institutes of Technology and an Institute of National Importance in India.
            The Institute is situated in a holy city, Prayagraj. Prayagraj is a sacred city where three rivers,
            the 'Ganges,' 'Yamuna,' and the invisible 'Saraswati' (mythical) meet and continue their journey further.
          </p>

          <p className="text-md md:text-lg text-gray-600 mb-4">
            Motilal Nehru National Institute of Technology Allahabad is an Institute with a total commitment to
            quality and excellence in academic pursuits. It was established as one of the seventeen Regional
            Engineering Colleges of India in 1961 as a joint enterprise of the Government of India and Uttar Pradesh.
            It was an associated college of the University of Allahabad, India's third oldest university.
            The Institute began by offering Bachelor's Degree Programs in Civil, Electrical, and Mechanical Engineering.
            It was the first in the country to start an undergraduate program in Computer Science & Engineering in 1976-77.
            Subsequently, in 1982-83, undergraduate programs in Electronics Engineering and Production & Industrial
            Engineering were started. The first Master's Program of the Institute was introduced by the Mechanical
            Engineering Department in the year 1966.
          </p>

          <p className="text-md md:text-lg text-gray-700 mb-4">
            The Institute now offers B.Tech.,{" "}
            <a
              href="https://www.mnnit.ac.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              M.Tech.
            </a>
            , Ph.D. Programs, MCA, MBA, M.Sc.
          </p>

          <p className="font-bold">
            For more detail:{" "}
            <a
              href="https://www.mnnit.ac.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline font-bold"
            >
              click here
            </a>{" "}
          </p>
        </div>

        {/* Right Side Content: Logos and Image */}
        <div className="flex flex-col items-center space-y-4">
          {/* Top Logos (side by side) */}
          {/* <div className="flex space-x-6">
            <img
              src={mnnit_1}
              alt="MNNIT Logo"
              className="w-20 h-auto"
            />
            <img
              src={mnnit_2}
              alt="Diamond Jubilee Logo"
              className="w-20"
            />
          </div> */}

          {/* MNNIT Full Image */}
          <img
            src={mnnit_image}
            alt="MNNIT Campus"
            className="w-full h-auto rounded-md shadow-md"
          />
        </div>
      </div>
    </div>
  );
};

export default AboutInstitute;
